<bb-transaction-signing-interface *ngIf="(challenge | async) as challengeData"
                                  [isPending]="pending | async"
                                  [error]="error | async"
                                  [transactionData]="txnData"
                                  [challengeType]="challengeData.challengeType"
                                  [challengeData]="challengeData.challengeData"
                                  [challengeError]="challengeData.error"
                                  [enableResendPushNotification]="enableResendPushNotification | async"
                                  (failure)="onFailure($event)"
                                  (success)="onSuccess()"
                                  (poll)="onPoll($event)"
                                  (post)="onPost($event)">
</bb-transaction-signing-interface>
